var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2267 12.25C23.2267 11.47 23.1567 10.72 23.0267 10H12.6667V14.26H18.5867C18.3267 15.63 17.5467 16.79 16.3767 17.57V20.34H19.9467C22.0267 18.42 23.2267 15.6 23.2267 12.25Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 22.9996C15.6367 22.9996 18.1267 22.0196 19.9467 20.3396L16.3767 17.5696C15.3967 18.2296 14.1467 18.6296 12.6667 18.6296C9.80668 18.6296 7.37668 16.6996 6.50668 14.0996H2.84668V16.9396C4.65668 20.5296 8.36668 22.9996 12.6667 22.9996Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50675 14.0903C6.28675 13.4303 6.15675 12.7303 6.15675 12.0003C6.15675 11.2703 6.28675 10.5703 6.50675 9.91031V7.07031H2.84675C2.09675 8.55031 1.66675 10.2203 1.66675 12.0003C1.66675 13.7803 2.09675 15.4503 2.84675 16.9303L5.69675 14.7103L6.50675 14.0903Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 5.38C14.2867 5.38 15.7267 5.94 16.8767 7.02L20.0267 3.87C18.1167 2.09 15.6367 1 12.6667 1C8.36668 1 4.65668 3.47 2.84668 7.07L6.50668 9.91C7.37668 7.31 9.80668 5.38 12.6667 5.38Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.41bf7330c35f40f2837540dba5ccdf91.svg";
export { ForwardRef as ReactComponent };